
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.667 4.167A.836.836 0 015.833 5H5v10h.833c.459 0 .834.375.834.834a.836.836 0 01-.834.833H4.167a.836.836 0 01-.834-.834V4.168c0-.458.375-.833.834-.833h1.666c.459 0 .834.374.834.833zm8.336 2.02l2.345 3.334a.832.832 0 01-.015.979l-2.5 3.333a.832.832 0 01-1.167.167.833.833 0 01-.166-1.166l1.5-2H8.333a.833.833 0 110-1.667H15c.014 0 .026.003.04.007.01.003.02.007.032.008L13.64 7.146a.833.833 0 111.363-.958z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.667 4.167A.836.836 0 015.833 5H5v10h.833c.459 0 .834.375.834.834a.836.836 0 01-.834.833H4.167a.836.836 0 01-.834-.834V4.168c0-.458.375-.833.834-.833h1.666c.459 0 .834.374.834.833zm8.336 2.02l2.345 3.334a.832.832 0 01-.015.979l-2.5 3.333a.832.832 0 01-1.167.167.833.833 0 01-.166-1.166l1.5-2H8.333a.833.833 0 110-1.667H15c.014 0 .026.003.04.007.01.003.02.007.032.008L13.64 7.146a.833.833 0 111.363-.958z"}})])
          )
        }
      }
    